export default "__VITE_ASSET__ClVhA5JA__"